// eslint-disable-next-line import/prefer-default-export
export const SAVE_LOCAL_CLIENT_TAGS = 'SAVE_LOCAL_CLIENT_TAGS';
